import React, { useEffect, useRef, useState } from 'react'
import { translate } from '../../Services/translation'
import { Link, c } from './common'

function MobileNavigation({ links: propsLinks = [], countryNav, footerItems }) {
    const [expanded, setExpanded] = useState(false)
    const [stack, setStack] = useState([])
    const menuRef = useRef()

    useEffect(() => {
        const style = document?.scrollingElement?.style
        if (!style) {
            return
        }

        style.overflowY = expanded ? 'hidden' : 'scroll'

        return () => {
            style.overflowY = 'scroll'
        }
    }, [expanded])

    const expand = () => setExpanded(true)
    const collapse = () => {
        setExpanded(false)
        setStack([])
    }

    const push = (link) => setStack((x) => [...x, link])
    const pop = () => setStack((x) => x.slice(0, -1))

    const rootLinks = [countryNav, ...propsLinks]
    const level = stack.length
    const contentLink = stack[level - 1]
    const links = contentLink?.links ?? rootLinks

    useEffect(() => {
        if (!menuRef.current) {
            return
        }
        menuRef.current.scrollTop = 0
    }, [contentLink])

    return (
        <>
            <HamburgerRoot onClick={expand} />
            <ul ref={menuRef} {...c('menu', { show: expanded })}>
                <div {...c('menu-header')}>
                    {level > 0 && <BackButton onClick={pop} />}
                    <CloseButton onClick={collapse} />
                </div>
                {contentLink && (
                    <>
                        <li {...c('item', 'heading')}>
                            <Link
                                className={[
                                    contentLink.isSelected && 'active',
                                ].filter(Boolean)}
                                onClick={contentLink.onClick}
                                href={contentLink.url}
                            >
                                {contentLink.name}
                            </Link>
                        </li>
                        <HorizontalRule />
                    </>
                )}
                {links.map((link, i) => (
                    <MenuItem
                        key={`${link.name}-${i}`}
                        link={link}
                        onClick={() => push(link)}
                    />
                ))}
                {level === 0 && <Footer items={footerItems} />}
            </ul>
            <Backdrop show={expanded} onClick={collapse} />
        </>
    )
}

function HamburgerRoot({ onClick }) {
    return (
        <a
            {...c('icon', 'menu', 'icon-menu navbar__link--block')} // HACK
            onClick={onClick}
        />
    )
}

function BackButton({ onClick }) {
    return (
        <button {...c('back-button')} onClick={onClick}>
            <i {...c('icon', 'caret-left', 'icon-arrow')} />
            <span {...c('title')}>{translate('navigation.back')}</span>
        </button>
    )
}

function CloseButton({ onClick }) {
    return <span {...c('icon', 'close', 'icon-close')} onClick={onClick} />
}

function MenuItem({ link, onClick }) {
    const { name, links, fullRule } = link
    if (!name) {
        return null
    }
    return (
        <>
            <li {...c('item')}>
                {links?.length > 0 ? (
                    <Branch {...link} onClick={onClick} />
                ) : (
                    <Leaf {...link} />
                )}
            </li>
            <HorizontalRule full={fullRule} />
        </>
    )
}

function Branch({ img, name, isSelected, onClick }) {
    return (
        <>
            {img && <img {...c('img')} {...img} />}
            <Link
                className={[isSelected && 'active'].filter(Boolean)}
                onClick={onClick}
            >
                {name}
            </Link>
            <i
                {...c('icon', ['open', 'caret-right'], 'icon-arrow')}
                onClick={onClick}
            />
        </>
    )
}

function Leaf({ img, isSelected, onClick, url, name }) {
    return (
        <>
            {img && <img {...c('img')} {...img} />}
            <Link
                className={[isSelected && 'active'].filter(Boolean)}
                onClick={onClick}
                href={url}
            >
                {name}
            </Link>
        </>
    )
}

function HorizontalRule({ full }) {
    return <hr style={full ? { margin: 0 } : {}} />
}

function Footer({ items }) {
    return (
        <div {...c('account-links-section')}>
            {items.map(({ href, text }) => (
                <li key={href} {...c('footer-item')}>
                    <a {...c('link')} href={href}>
                        {text}
                    </a>
                </li>
            ))}
        </div>
    )
}

function Backdrop({ show, onClick }) {
    return <div {...c('backdrop', { show })} onClick={onClick} />
}

export default MobileNavigation
